import baseServices from '../../../services/base.services'

const getAData = async () => {
    try {
        var response = await baseServices.getDataTostacionDMH2({ opcion: 994, orden: 994, ultimo: 994, frecuencia: 994, periodo: 994 })
        if (response.data && response.data.length > 0) return response.data
        else return null
    }
    catch (e) {
        console.log(e)
        getAData()
    }
}

const updateData = async (body) => {
    try {
        var response = await baseServices.updateDataTostacionDMH(body)
        if (response.data && response.data.length > 0) return response.data
        else return null
    }
    catch (e) {
        console.log(e)
    }
} 

const exportedObject = {
    getAData,
    updateData
}

export default exportedObject